import React, { useEffect, useState } from "react";
import BlockController from "./BlockController";
import axios from "axios";
import BlockDataFilter from "./TableView/BlockDataFilter";
import SectionWiseBlockChart from "./Block charts/Section wise/SectionWiseBlockChart";
import BlockPositionChart from "./Block charts/Block Position/BlockPositionChart";
import MachineENGChart from "./Block charts/Machine (ENG)/MachineENGChart";
import SummeryChart from "./Block charts/Summery/SummeryChart";
import AdrmGraphMaster from "./TableView/ADRMDailyBlockPosition/Graph/AdrmGraphMaster";
import CountSectionWiseBlockChart from "./Block charts/Section wise/CountSectionWiseBlockChart";

const BlockReportMaster = ({ data, dataForTable, dates }) => {
  // /////////////////////////////////FLETCH FUNCTION/////////////////////////////////////////////////
  return (
    <div>
      <SummeryChart data={data} dates={dates} />

      <BlockPositionChart data={data} dataForTable={dataForTable} />
      <SectionWiseBlockChart data={data} dataForTable={dataForTable} />
      <CountSectionWiseBlockChart data={data} dataForTable={dataForTable} />
      <MachineENGChart data={data} />
      <AdrmGraphMaster dates={dates} />
    </div>
  );
};
export default BlockReportMaster;
